import { render } from "./liste.vue?vue&type=template&id=2cf705a2&scoped=true"
import script from "./liste.vue?vue&type=script&lang=js"
export * from "./liste.vue?vue&type=script&lang=js"

import "./liste.vue?vue&type=style&index=0&id=2cf705a2&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf705a2"]])

export default __exports__